import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import {RawLocation} from 'vue-router';
import * as _ from 'lodash';
import {Dictionary} from 'vue-router/types/router';

@Component
export class RegistrationVue extends Vue {

  scrollEvent;

  constructor() {
    super();
  }

  mounted() {
    const preservedY = this.$store.state.scrolls[this.$route.path];
    if (this.$route.query.routerback && preservedY) {
      window.scroll(0, preservedY);
    } else {
      window.scroll(0, 0);
    }

    this.scrollEvent = window.addEventListener('scroll', () => {
      if (this.$store) {
        this.$store.state.scrolls[this.$route.path] = window.scrollY;
      }
    });
  }

  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollEvent);
  }

  handleApiError(error) {
    console.debug(`Incoming API error`, error);
    this.alert('Something went wrong. Give us a ring on 0800 463 996.');
  }

  alert(text) {
    this.$root['alert'](text);
  }

  navigate(page: string, query?: Dictionary<string>, options?: RawLocation) {
    this.$router.push(_.extend({}, { path: page, query: query }, options));
  }

  invalidateField(fieldName: string, message: string) {
    this.$validator.errorBag.add(fieldName, message, undefined);
  }

  doIfFormIsValid(callBack: Function) {
    this.$validator.validateAll().then(valid => {
      if (valid) {
        callBack()
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/registration-vue.ts